import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=74a277ad&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a277ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a277ad')) {
      api.createRecord('74a277ad', component.options)
    } else {
      api.reload('74a277ad', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=74a277ad&scoped=true&", function () {
      api.rerender('74a277ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2L9MoID4sXSvZ/JS/comp/Accordion.vue"
export default component.exports